/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Internal dependencies
 */
import * as beautyStickers from './fresh-and-bright';
import * as cookingStickers from './food-and-stuff';
import * as doersGetMoreDoneStickers from './doers-get-more-done';
import * as weeklyEntertainmentStickers from './weekly-entertainment';
import * as fashionOnTheGoStickers from './fashion-on-the-go';
import * as noDaysOffStickers from './no-days-off';
import * as experienceThailandStickers from './experience-thailand';
import * as wellbeingSleepStickers from './sleep';
import * as guideTobakingBreadStickers from './baking-bread-guide';
import * as sangriaArtichokeStickers from './sangria-artichoke';
import * as crispyChickenThighStickers from './kitchen-stories';
import * as almondosFilmsStickers from './almodos-films';
import * as bestPizzaInNYCStickers from './pizzas-in-nyc';
import * as twelveHoursInBarcelonaStickers from './12-hours-in-barcelona';
import * as bestFitnessAppsStickers from './fitness-apps-ranked';
import * as streetStyleOnTheGoStickers from './street-style-on-the-go';
import * as plantBasedDyesStickers from './plant-based-dyes';
import * as indoorGardenOasisStickers from './indoor-garden-oasis';
import * as killBellyFatStickers from './belly-fat-workout';
import * as crownSeasonsRecappedStickers from './tv-show-recap';
import * as honeymooningInItalyStickers from './honeymooning-in-italy';
import * as stayAtAceHotelKyotoStickers from './ace-hotel-kyoto-review';
import * as videoCallsSavedTheDayStickers from './how-video-calls-saved-the-day';
import * as pickTheRightLaptopStickers from './laptop-buying-guide';
import * as quizForYourBestSkinStickers from './beauty-quiz';
import * as atHomeOfficeStickers from './diy-home-office';
import * as rockMusicFestivalStickers from './rock-music-festival';
import * as losAngelesCityGuideStickers from './los-angeles-city-guide';
import * as hawaiiTravelPackingListStickers from './hawaii-travel-packing-list';
import * as howContactTracingWorksStickers from './how-contact-tracing-works';
import * as summerFashionCollectionStickers from './summer-fashion-collection';
import * as artOnTheInternetStickers from './buying-art-on-the-internet';
import * as newYorkPartyRoundUpStickers from './new-york-party-round-up';
import * as aDayInTheLifeStickers from './a-day-in-the-life';
import * as elegantTravelItineraryStickers from './elegant-travel-itinerary';
import * as modernistTravelGuideStickers from './modernist-travel-guide';
import * as magazineArticleStickers from './magazine-article';
import * as fashionInspirationStickers from './fashion-inspiration';
import * as skinCareAtHomeStickers from './skin-care-at-home';
import * as artBooksGiftGuideStickers from './art-books-gift-guide';
import * as vintageChairsWhatToLookForStickers from './vintage-chairs-what-to-look-for';
import * as celebrityLifeStoryStickers from './celebrity-life-story';
import * as summerAdventureGuideStickers from './summer-adventure-guide';
import * as oneDayCityItineraryStickers from './one-day-city-itinerary';
import * as technologyAdviceStickers from './technology-advice';
import * as allAboutCarsStickers from './all-about-cars';
import * as sustainabilityTipsStickers from './sustainability-tips';
import * as anArtistsLegacyStickers from './an-artists-legacy';
import * as tipsForThrowingAnOutdoorLuauStickers from './tips-for-throwing-an-outdoor-luau';

export default {
  ...beautyStickers,
  ...cookingStickers,
  ...doersGetMoreDoneStickers,
  ...weeklyEntertainmentStickers,
  ...fashionOnTheGoStickers,
  ...noDaysOffStickers,
  ...experienceThailandStickers,
  ...wellbeingSleepStickers,
  ...guideTobakingBreadStickers,
  ...sangriaArtichokeStickers,
  ...crispyChickenThighStickers,
  ...almondosFilmsStickers,
  ...bestPizzaInNYCStickers,
  ...twelveHoursInBarcelonaStickers,
  ...bestFitnessAppsStickers,
  ...streetStyleOnTheGoStickers,
  ...plantBasedDyesStickers,
  ...indoorGardenOasisStickers,
  ...killBellyFatStickers,
  ...crownSeasonsRecappedStickers,
  ...honeymooningInItalyStickers,
  ...stayAtAceHotelKyotoStickers,
  ...videoCallsSavedTheDayStickers,
  ...pickTheRightLaptopStickers,
  ...quizForYourBestSkinStickers,
  ...atHomeOfficeStickers,
  ...rockMusicFestivalStickers,
  ...losAngelesCityGuideStickers,
  ...hawaiiTravelPackingListStickers,
  ...howContactTracingWorksStickers,
  ...summerFashionCollectionStickers,
  ...artOnTheInternetStickers,
  ...newYorkPartyRoundUpStickers,
  ...aDayInTheLifeStickers,
  ...elegantTravelItineraryStickers,
  ...modernistTravelGuideStickers,
  ...magazineArticleStickers,
  ...fashionInspirationStickers,
  ...skinCareAtHomeStickers,
  ...artBooksGiftGuideStickers,
  ...vintageChairsWhatToLookForStickers,
  ...celebrityLifeStoryStickers,
  ...summerAdventureGuideStickers,
  ...oneDayCityItineraryStickers,
  ...technologyAdviceStickers,
  ...allAboutCarsStickers,
  ...sustainabilityTipsStickers,
  ...anArtistsLegacyStickers,
  ...tipsForThrowingAnOutdoorLuauStickers,
};
